export default "__VITE_ASSET__BpQWTmCW__"